<template>
  <div class="page" v-loading="loading">
    <el-tabs v-model="form.isModelCodeType" @tab-click="getData">
      <el-tab-pane label="商品库存管理" name="1"></el-tab-pane>
      <el-tab-pane label="型号库存管理" name="2"></el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="spuId" prop="spuId">
            <el-input v-model="form.spuId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="skuId" prop="skuId">
            <el-input v-model="form.skuId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="型号" prop="modelCode">
            <el-input v-model="form.modelCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="仓级筛选" prop="level">
            <el-select v-model="form.level" style="width: 100%;" clearable>
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="一级"></el-option>
              <el-option :value="2" label="二级"></el-option>
              <el-option :value="3" label="三级"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="display:flex;">
            <el-form-item label="仓库库存" prop="calculateStoreType">
              <el-select v-model="form.calculateStoreType" style="width:120px;" clearable>
                <el-option :value="1" label="大于"></el-option>
                <el-option :value="2" label="大于等于"></el-option>
                <el-option :value="3" label="等于"></el-option>
                <el-option :value="3" label="小于"></el-option>
                <el-option :value="3" label="小于等于"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="calculateStoreValue" label-width="0">
              <el-input v-model="form.calculateStoreValue"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <el-form-item label="分销商">
            <el-select v-model="form.supId" filterable remote :remote-method="remoteReseller" placeholder="分销商"
              style="width:100%;">
              <el-option v-for="(item, index) in resellerList" :key="index" :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <toolbar :buttonList="buttonList_toolBar.filter(item => item.buttonFunc === 'importStockSku')"
          @callFunction="callFunction" v-if="form.isModelCodeType === '1'">
        </toolbar>
        <toolbar :buttonList="buttonList_toolBar.filter(item => item.buttonFunc === 'importStockModelCode')"
          @callFunction="callFunction" v-if="form.isModelCodeType === '2'">
        </toolbar>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <template v-if="form.isModelCodeType === '1'">
        <el-table-column label="spuId" prop="spuId"></el-table-column>
        <el-table-column label="skuId" prop="skuId"></el-table-column>
        <el-table-column label="商品标题" prop="skuName"></el-table-column>
      </template>
      <template v-if="form.isModelCodeType === '2'">
        <el-table-column label="型号" prop="modelCode"></el-table-column>
      </template>
      <el-table-column label="所属仓库" prop="stockName"></el-table-column>
      <el-table-column label="仓级" prop="stockLevel"></el-table-column>
      <el-table-column label="库存" prop="stockNum"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.pageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <stockDetail ref="stockDetail" :loading.sync="loading" />
    <UploadFile ref="UploadFile" @confirm="uploadFileConfirm" :supId="form.supId"/>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import {
  KSAXApiRequest,
  KSAXApiUpload,
  GetAllReseller
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import stockDetail from "./components/StockDetail.vue"
import UploadFile from "./components/UploadFile.vue"

export default {
  components: { Toolbar, stockDetail, UploadFile },
  data() {
    return {
      resellerList: [],
      loading: false,
      tableData: [],
      total: 0,
      buttonList_toolBar: [],
      buttonList_table: [],
      form: {
        skuId: null,
        spuId: null,
        modelCode: null,
        level: null,
        stockName: null,
        deliverArea: null,
        calculateStoreType: null,
        calculateStoreValue: null,
        pageIndex: 1,
        pageSize: 10,
        supId: null,
        isModelCodeType: "1"
      },
      uploadFileType: ""
    };
  },
  created() {
    this.getAllReseller()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    var buttonList = getButtonList(this.$route.path, routers) || []
    this.buttonList_toolBar = buttonList.filter(item => item.buttonShow === 10);
    this.buttonList_table = buttonList.filter(item => item.buttonShow === 20);
  },
  methods: {
    getAllReseller() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.form.supId = res.data.result.items[0].remoteKey
          this.resellerList = res.data.result.items.map((item) => {
            return {
              value: item.name,
              id: item.remoteKey,
              supType: item.supType
            };
          });
          this.queryData()
        }
      })
    },
    remoteReseller(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        GetAllReseller(obj).then((res) => {
          if (res.data.success) {
            this.resellerList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.remoteKey,
                supType: item.supType
              };
            });
            resolve(this.resellerList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    queryData() {
      this.loading = true
      KSAXApiRequest({
        path: 'Product_MultistageStockSku/List',
        parmsJson: {
          ...this.form,
          calculateStoreValue: this.form.calculateStoreValue || 0
        }
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data || []
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    getData() {
      this.form.pageIndex = 1
      this.form.pageSize = 10
      this.queryData()
    },
    handleSizeChange(value) {
      this.form.pageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.pageIndex = value
      this.queryData()
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.getData()
    },
    stockDetail(item, index, row) {
      this.$refs.stockDetail.init(row.skuId, this.form.supId, row.modelCode, this.form.isModelCodeType)
    },
    stockDelete(item, index, row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        KSAXApiRequest({
          path: 'Product_MultistageStockSku/DeleteStockSku',
          parmsJson: { id: row.id }
        }).then(res => {
          this.loading = false
          if (res.data.success) {
            this.$message.success(res.data.msg)
            this.queryData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    importStockSku() {
      this.uploadFileType = "id"
      this.$refs.UploadFile.init(
        "供应商库存导入-id",
        "https://homeimage.ksaxshop.com/%E4%BE%9B%E5%BA%94%E5%95%86%E5%95%86%E5%93%81%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
        "id"
      )
    },
    importStockModelCode() {
      this.uploadFileType = "modelCode"
      this.$refs.UploadFile.init(
        "供应商库存导入-型号",
        "https://homeimage.ksaxshop.com/%E4%BE%9B%E5%BA%94%E5%95%86%E5%BA%93%E5%AD%98%E5%9E%8B%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
        "modelCode"
      )
    },
    xlsxList(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (e) => {
          try {
            const workbook = XLSX.read(e.target.result, {
              type: 'array',
              cellDates: true
            })

            const sheet = workbook.Sheets[workbook.SheetNames[0]]
            // 兼容旧版excel文件，将错误类型转为字符串
            // Object.keys(sheet).forEach(addr => {
            //   if (addr.startsWith('!')) return

            //   const cell = sheet[addr]

            //   if (cell && cell.t === 'e') {
            //     cell.t = 's'
            //     cell.v = 'ERROR'
            //     cell.w = 'ERROR'
            //   }
            // })
            const list = XLSX.utils.sheet_to_json(sheet, {
              defval: '',
              raw: false
            })

            const result = list.map(item => {
              const obj = {}

              Object.keys(item).forEach(key => {
                const arr = key.split('-')
                const newKey = arr[arr.length - 1]
                obj[newKey] = item[key] === '' ? 0 : item[key]
              })

              return obj
            })
            let validateFields = [
              { key: 'StockId', name: '仓库ID', required: true, gtZero: true },
              { key: 'StockNum', name: '数量', required: true }
            ]
            if (this.uploadFileType === "id") {
              validateFields.push(
                { key: 'SkuId', name: '商品ID', required: true, gtZero: true }
              )
            } else if (this.uploadFileType === "modelCode") {
              validateFields.push(
                { key: 'ModelCode', name: '商品型号', required: true }
              )
            }
            let errorMsg = ''
            result.some((item, index) => {
              return validateFields.some(field => {
                const value = item[field.key]
                if (field.required && (value === '' || value === null || value === undefined)) {
                  errorMsg = `Excel第 ${index + 2} 行【${field.name}】不能为空`
                  return true
                }
                if (field.gtZero && (isNaN(Number(value)) || Number(value) <= 0)) {
                  errorMsg = `Excel第 ${index + 2} 行【${field.name}】必须大于0`
                  return true
                }
                return false
              })
            })
            if (errorMsg) {
              this.$message.error(errorMsg)
              return
            }
            resolve(result)
          } catch (err) {
            reject(err)
          }
        }
        reader.onerror = reject
        reader.readAsArrayBuffer(file)
      })
    },
    async uploadFileConfirm(file) {
      if (!file) {
        return this.$message.warning('请上传文件');
      }
      let path = ""
      if (this.uploadFileType === "id") {
        path = `Product_MultistageStockSku/ImportStockSku`
      }
      if (this.uploadFileType === "modelCode") {
        path = `Product_MultistageStockSku/ImportStockModelCode`
      }
      try {
        const result = await this.xlsxList(file)
        // console.log(result)
        KSAXApiRequest({
          path,
          parmsJson: {
            supId: this.form.supId,
            stockList: result
          }
        }).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.$refs.UploadFile.dialogVisible = false
            this.queryData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } catch (err) {
        this.$message.error('Excel解析失败')
      }
      // let formData = new window.FormData();
      // formData.append("file", file);
      // KSAXApiUpload(formData).then((res) => {
      //   KSAXApiRequest({
      //     path,
      //     parmsJson: {
      //       supId: this.form.supId,
      //       stockList: res.data.slice(1)
      //     }
      //   }).then(res => {
      //     if (res.data.success) {
      //       this.$message.success(res.data.msg);
      //       this.$refs.UploadFile.dialogVisible = false
      //       this.queryData()
      //     } else {
      //       this.$message.error(res.data.msg)
      //     }
      //   })
      // })
    }
  },
};
</script>

<style scoped></style>
